<span class="channel-count-badge">{{ count }}</span>
